import * as React from "react"
import type { ReactNode } from 'react'
import './FormField.css'

interface Props {
  label: string
  htmlFor: string
  hint?: string
  error?: string | undefined
  required?: boolean
  children: ReactNode
}

/**
 * Label + control + hint + error in one. Wrap an <Input> or <select> in
 * this; never style labels per-page.
 */
export function FormField({ label, htmlFor, hint, error, required, children }: Props): React.JSX.Element {
  const hintId = hint ? `${htmlFor}-hint` : undefined
  const errorId = error ? `${htmlFor}-error` : undefined
  return (
    <div className="form-field">
      <label htmlFor={htmlFor} className="form-field-label">
        {label}
        {required ? <span aria-hidden="true" className="form-field-req"> *</span> : null}
      </label>
      {children}
      {hint && !error ? (
        <p id={hintId} className="form-field-hint">
          {hint}
        </p>
      ) : null}
      {error ? (
        <p id={errorId} className="form-field-error" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  )
}
